const IsniSkeletonLoader = () => {
  return (
    <div className="h-5 w-40 bg-gray-300 rounded-xl shadow-md animate-pulse" />
  );
};

export default IsniSkeletonLoader;
